<template>
    <fragment>
        <div v-if="selectedAdvisor && selectedAdvisor.banner" v-html="selectedAdvisor.banner"></div>
        <div class="advisor-details">
            <div class="advisor-details-outer">
                <div class="row advisor-details-inner">
                    <div class="col-lg-6 advisor-search-container single">
                        <div class="advisor-search-container__results--list-item">
                            <div class="row back-cta-block" v-if="!isSpecificAdvisor">
                                <div class="col-12">
                                    <button v-on:click.stop="unSelectAdvisorClick">{{ text("backToResults") }}</button>
                                </div>
                            </div>
                            <div class="row advisor-search-container__heading d-sm-flex d-md-none">
                                <div class="advisor-search-container__image col" v-if="selectedAdvisor.image">
                                    <img :src="selectedAdvisor.image" :alt="(selectedAdvisor.firstName + ' ' + selectedAdvisor.lastName)" tabindex="-1" ref="mobileImageRef" />
                                </div>
                                <div class="col mobile-custom-adjustment">
                                    <strong v-if="selectedAdvisor.isInvestmentServices">{{ text("investmentServicesHeading") }}</strong>
                                    <h1 class="h3 advisor-search-container__name">{{ selectedAdvisor.firstName }} {{ selectedAdvisor.lastName }}</h1>
                                    <div class="advisor-search-container__jobtitle" v-if="selectedAdvisor.advisorTitle">{{ selectedAdvisor.advisorTitle }}</div>
                                    <div class="cta_btns" v-if="selectedAdvisor.applyNowCta || selectedAdvisor.clientLoginCta" v-html="ctaHtml"></div>
                                </div>
                            </div>
                            <div class="row advisor-search-container__npn d-sm-block d-md-none" v-if="selectedAdvisor.nmlsNumber || selectedAdvisor.ailNumber || selectedAdvisor.npmNumber">
                                <div v-if="selectedAdvisor.nmlsNumber" class="col">{{ text("nmls") }} #{{ selectedAdvisor.nmlsNumber }}</div>
                                <div v-if="selectedAdvisor.ailNumber" class="col">{{ text("ail") }} #{{ selectedAdvisor.ailNumber }}</div>
                                <div v-if="selectedAdvisor.npmNumber" class="col">{{ text("npn") }} #{{ selectedAdvisor.npmNumber }}</div>
                            </div>
                            <div class="row advisor-search-container__detail">
                                <div class="col-4 d-none d-md-flex">
                                    <div class="advisor-search-container__image">
                                        <img :src="selectedAdvisor.image" :alt="(selectedAdvisor.firstName + ' ' + selectedAdvisor.lastName)" tabindex="-1" ref="desktopImageRef" />
                                        <div class="advisor-search-container__npn" v-if="selectedAdvisor.nmlsNumber">{{ text("nmls") }} #{{ selectedAdvisor.nmlsNumber }}</div>
                                        <div class="advisor-search-container__npn" v-if="selectedAdvisor.ailNumber">{{ text("ail") }} #{{ selectedAdvisor.ailNumber }}</div>
                                        <div class="advisor-search-container__npn" v-if="selectedAdvisor.npmNumber">{{ text("npn") }} #{{ selectedAdvisor.npmNumber }}</div>
                                    </div>
                                    <div class="col d-none d-sm-block d-md-none">
                                        <h2 class="h3 advisor-search-container__name">{{ selectedAdvisor.firstName }} {{ selectedAdvisor.lastName }}</h2>
                                        <div class="advisor-search-container__jobtitle" v-if="selectedAdvisor.advisorTitle">{{ selectedAdvisor.advisorTitle }}</div>
                                        <div class="cta_btns" v-if="selectedAdvisor.applyNowCta || selectedAdvisor.clientLoginCta" v-html="ctaHtml"></div>
                                    </div>
                                </div>
                                <div class="col details">
                                    <div class="section d-none d-md-block">
                                        <h2 class="h3 advisor-search-container__name">{{ selectedAdvisor.firstName }} {{ selectedAdvisor.lastName }}</h2>
                                        <div class="advisor-search-container__jobtitle" v-if="selectedAdvisor.advisorTitle">{{ selectedAdvisor.advisorTitle }}</div>
                                        <div class="cta_btns" v-if="selectedAdvisor.applyNowCta || selectedAdvisor.clientLoginCta" v-html="ctaHtml"></div>
                                    </div>
                                    <div class="section" v-if="selectedAdvisor.finraBrokerCheck">
                                        {{ text("finraDescriptor") }}<br />
                                        <a class="link" :href="'https://brokercheck.finra.org/individual/summary/' + selectedAdvisor.finraBrokerCheck" target="_blank">{{ selectedAdvisor.finraBrokerCheck }}</a>
                                    </div>
                                    <div class="section" v-if="hasPhone">
                                        <h3>{{ text("callHeadline") }}</h3>
                                        <span v-if="selectedAdvisor.officePhoneNumber">P: <a v-if="selectedAdvisor.officePhoneNumber" v-bind:href="this.telephoneHref(selectedAdvisor.officePhoneNumber)" class="tel link">{{ formatTelephone(selectedAdvisor.officePhoneNumber) }}</a></span>
                                        <br v-if="selectedAdvisor.officePhoneNumber" />
                                        <span v-if="selectedAdvisor.cellPhoneNumber">C: <a v-if="selectedAdvisor.cellPhoneNumber" v-bind:href="this.telephoneHref(selectedAdvisor.cellPhoneNumber)" class="tel link">{{ formatTelephone(selectedAdvisor.cellPhoneNumber) }}</a></span>
                                        <br v-if="selectedAdvisor.cellPhoneNumber" />
                                        <span v-if="selectedAdvisor.faxPhoneNumber">F: <span class="tel link">{{ formatTelephone(selectedAdvisor.faxPhoneNumber) }}</span></span>
                                    </div>
                                    <div class="section advisor-search-container__languages" v-if="false">
                                        <h3>{{ text("languagesHeading") }}</h3>
                                        {{ selectedAdvisor.languages }}
                                    </div>
                                    <div class="section" v-if="selectedAdvisor.emailAddress || selectedAdvisor.linkedInConnection">
                                        <h3>{{ text("emailHeading") }}</h3>
                                        <a v-if="selectedAdvisor.emailAddress" v-bind:href="emailHref" class="email link">{{ selectedAdvisor.emailAddress }}</a><br />
                                        <a v-if="selectedAdvisor.linkedInConnection" v-bind:href="selectedAdvisor.linkedInConnection" target="_blank" class="link">{{ text("connectCta") }}</a><br />
                                    </div>
                                    <div class="section" v-if="selectedAdvisor.address && !isDirectConsumer">
                                        <h3>{{ text("visitHeading") }}</h3>
                                        <span v-html="address"></span>
                                    </div>
                                    <div class="section" v-if="selectedAdvisor.address && !isDirectConsumer">
                                        <img src="/static/assets/images/directions_icon.svg" alt="" /> <a v-bind:href="directions" target="_blank" class="link">{{ text("directions") }}</a><br />
                                        <img class="icon" src="/static/assets/images/information_icon.svg" alt="" /> <a :href="selectedAdvisor.locationDetailPageUrl" target="_blank" class="link">{{ text("branchInfo") }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6"></div>
                </div>
                <div v-if="!isDirectConsumer" class="map-container advisor-details-map" role="region" aria-label="map">
                    <google-map
                        ref="map"
                        :zoom="16"
                        :center="center"
                        class="map"
                        @click="expandMap"
                        :options="{
                            styles: mapStyles,
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false, 
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: true,
                            disableDefaultUi: false
                        }"
                    >
                        <google-marker
                            ref="myMarker"
                            v-for="m in marker"
                            :key="m.id"
                            :title="m.title"
                            :position="m.position"
                            :icon="m.icon"
                        ></google-marker>
                    </google-map>
                </div>
            </div>
            <div v-if="selectedAdvisor.disclaimers && fromListPage" class="container full-width-container bleed-bgs disclaimer-container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="disclaimer disclaimer-ul" v-html="selectedAdvisor.disclaimers"></div>
                    </div>
                </div>
            </div>
        </div>
    </fragment>
</template>

<script>
import { mapActions } from "vuex";
import { locText } from "../../../utils/useText";
import { formatAddress, formatDirectionsLink, formatEmailLink, formatPhoneNumber, formatTelephoneHref } from "../../../utils/functions";
import { googleApi, defaultOpt, mapStyles } from "../../../config/map";
import Vue from "vue";
import VueMq from "vue-mq";
import * as VueGoogleMaps from "vue2-google-maps";

// Vue Google Maps Init
Vue.use(VueGoogleMaps, {
  load: {
    key: googleApi.mapKey,
    libraries: ["places"],
    v: "3.40"
  },
  installComponents: false
});

  Vue.use(VueMq, {
    breakpoints: {
      mobile: 678,
      tablet: 992,
      desktop: Infinity
    }
  });

const MARKER_ICON = "/Static/assets/images/branch.svg";

export default {
    data() {
        return {
            center: defaultOpt.pos,
            marker: [],
          mapStyles: []
        }
    },
    mounted() {
        if(!this.isDirectConsumer) {
            this.$refs.map.$mapPromise.then(() => {
                this.marker.push({
                    id: this.selectedAdvisor.id,
                    title:  this.selectedAdvisor.fullName,
                    position:  {
                        lat:  this.selectedAdvisor.geocode.latitude,
                        lng:  this.selectedAdvisor.geocode.longitude
                    },
                    icon: {
                        url: MARKER_ICON,
                        size: new window.google.maps.Size(30,30),
                        origin: new window.google.maps.Point(0,0),
                        anchor: new window.google.maps.Point(0,0),
                        labelOrigin: new window.google.maps.Point(55, 35),
                        scaledSize: new window.google.maps.Size(30,30),
                        optimized: false
                    }
                });
                setTimeout(() => {
                    this.boundMarkers();
                }, 0);
            });
        }

        if (!this.userSearchLocation || !this.userSearchLocation.lat || !this.userSearchLocation.lng) {
            this.geolocateUser();
        }

        if (typeof HERO_speedbump != "undefined") {
            setTimeout(function(){ 
                HERO_speedbump.init();
            }, 1000);
        }

        if (this.isMobile)
        {
            this.$refs.mobileImageRef.focus();
        }
        else {
            this.$refs.desktopImageRef.focus();
        }
    },
    components: {
        "google-map": VueGoogleMaps.Map,
        "google-marker": VueGoogleMaps.Marker
    },
    computed: {
        isMobile() {
            return this.$mq === 'mobile';
        },
        address() {
            return formatAddress(this.selectedAdvisor);
        },
        ctaHtml() {
            let html = "";
            if (this.selectedAdvisor.applyNowCta) {
                html = this.selectedAdvisor.applyNowCta;
                if (this.selectedAdvisor.clientLoginCta) {
                    html = html.concat(this.selectedAdvisor.clientLoginCta);
                }
            }
            else if (this.selectedAdvisor.clientLoginCta) {
                html = this.selectedAdvisor.clientLoginCta;
            }
            return html;
        },
        directions() {
            return formatDirectionsLink(this.selectedAdvisor, this.userSearchLocation);
        },
        distance() {
            return parseFloat(this.selectedAdvisor.distance).toFixed(1) + " " + this.text("distance");
        },
        emailHref() {
            return formatEmailLink(this.selectedAdvisor);
        },
        formattedPhoneNumber() {
            return formatPhoneNumber(this.phone);
        },
        hasPhone() {
            return this.selectedAdvisor.officePhoneNumber || this.selectedAdvisor.cellPhoneNumber || this.selectedAdvisor.faxPhoneNumber;
        },
        isSpecificAdvisor() {
            return this.$store.getters.isSpecificAdvisor;
        },
        selectedAdvisor() {
            return this.$store.getters.selectedAdvisor;
        },
        userSearchLocation() {
            return this.$store.getters.userSearchLocation;
        },
        isDirectConsumer: {
            get() {
                return this.$store.getters.isDirectConsumer;
            }
        }
    },
    methods: {
        ...mapActions(["geolocateUser"]),
        boundMarkers() {
            this.$gmapApiPromiseLazy().then(() => {
                const bounds = new window.google.maps.LatLngBounds();
                for (var m in this.marker) {
                    if (this.marker.hasOwnProperty(m)) {
                        let lat = parseFloat(this.marker[m].position.lat);
                        let lng = parseFloat(this.marker[m].position.lng);
                        let myLatlng = new window.google.maps.LatLng(lat, lng);
                        bounds.extend(myLatlng);
                    }
                }

                // Don't zoom in too far on only one marker
                if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                    var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.001, bounds.getNorthEast().lng() + 0.001);
                    var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.001, bounds.getNorthEast().lng() - 0.001);
                    bounds.extend(extendPoint1);
                    bounds.extend(extendPoint2);
                }

                this.$refs.map.fitBounds(bounds);
                // Prevent bounding on filtering
                this.newSearch = false;
            });
        },
        contractMap(){
            if(this.$mq !== 'desktop') {
                EventBus.expandMap(false);
                setTimeout(()=> {  
                    EventBus.scrollToTopMobile();
                },600);
            }
        },
        expandMap(){
            EventBus.expandMap(true);
            EventBus.scrollToTopMobile(0);
        },
        telephoneHref(phoneNumber) {
            return formatTelephoneHref(phoneNumber);
        },
        formatTelephone(phoneNumber) {
            return formatPhoneNumber(phoneNumber);
        }
    },
    mixins: [locText],
    props: {
        fromListPage: Boolean,
        unSelectAdvisorClick: Function
    }
}
</script>
